import { connect } from "react-redux";
import { getTiffData, getExpectedExchangeDate } from "./actions";
import { fetchAccountData } from "../../../../../../actions/globalActions";
import TIFFViewAndEditInto from "../../Components/TIFFViewAndEditInto";
import { ViewEditIntoTiffDerivedStates } from "./selectors";

const mapStateToProps = state => ({
  ...ViewEditIntoTiffDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  getData: data => dispatch(getTiffData(data)),
  getExchangeDate: data => dispatch(getExpectedExchangeDate(data)),
  requestDataTiff: data => dispatch(fetchAccountData(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TIFFViewAndEditInto);
